import {
  Classpass,
  JustEat,
  UberEats,
} from '../../../../../Assets/Images/logos'

export const testimonialMessages = [
  {
    message:
      'At Uber Eats, we have ambitious growth targets in both our established markets and in our new territories. Promofy helps us to reach those targets thanks to their scalability and reach across the UK and Ireland.',
    author: 'Valerie Voloboy',
    role: 'Operations Manager',
    company: 'UberEats',
  },
  {
    message:
      'Flyering is an effective lever of our customer acquisition strategy and Promofy is able to reach such a low Cost per Acquisition!',
    author: 'Sara Sauvé',
    role: 'Activation Coordinator',
    company: 'JustEat',
  },
  {
    message:
      'Entering Australia as an American company was a challenge for us to localize with both consumers and partners. Promofy has helped us have feet on the ground. Promofy has helped us drive both consumer and partner awareness over the years.',
    author: 'Allie Mairs',
    role: 'General Manager ANZ',
    company: 'Classpass',
  },
]

export const TestimonialLogos = {
  UberEats: UberEats,
  JustEat: JustEat,
  Classpass: Classpass,
}
